import { formatStandardDateTime } from 'utils'

export const getTeamSubtitleInfo = (team, allUsers) => {
    let subtitle = `${ team.userIds.length } member${team.userIds.length !== 1 ? 's' : ''}, ${ team.projectIds.length } project${team.projectIds.length !== 1 ? 's' : '' } • Created ${ formatStandardDateTime(team, 'created_at', true) }`

    let creator = null

    if(team.user_id){
        creator = allUsers[team.user_id]
    }

    if(creator){
        subtitle += ' by '+creator.first_name+' '+creator.last_name
    }

    return subtitle
}